import { render } from "./CardWizard.vue?vue&type=template&id=bcbaabbc&scoped=true&bindings={\"title\":\"props\",\"titleClass\":\"props\",\"showProgress\":\"props\"}"
import script from "./CardWizard.vue?vue&type=script&lang=js"
export * from "./CardWizard.vue?vue&type=script&lang=js"

import "./CardWizard.vue?vue&type=style&index=0&id=bcbaabbc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bcbaabbc"

export default script